import React, {CSSProperties} from 'react';
import {
    SliderMenuPhoto1,
    SliderMenuPhoto2,
    SliderMenuPhoto3,
    SliderMenuPhoto4,
    SliderMenuPhoto5,
    SliderMenuPhoto6,
    SliderMenuPhoto7,
    SliderMenuPhoto8,
} from "../Assets";

import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import {Autoplay, Pagination, Navigation} from "swiper";

export default function SliderMenuComponent() {
    return (
        <>
            <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                modules={[Autoplay, Pagination, Navigation]}
                className="w-full"
                style={{
                    "--swiper-pagination-color": "#D6AD60",
                    "--swiper-navigation-color": "#D6AD60",
                } as CSSProperties}
            >
                <SwiperSlide>
                    <img
                        className="object-fill w-full h-2/3"
                        src={SliderMenuPhoto1}
                        alt="image slide 1"
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <img
                        className="object-fill w-full h-2/3"
                        src={SliderMenuPhoto2}
                        alt="image slide 2"
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <img
                        className="object-fill w-full h-2/3"
                        src={SliderMenuPhoto3}
                        alt="image slide 3"
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <img
                        className="object-fill w-full h-2/3"
                        src={SliderMenuPhoto4}
                        alt="image slide 1"
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <img
                        className="object-fill w-full h-2/3"
                        src={SliderMenuPhoto5}
                        alt="image slide 2"
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <img
                        className="object-fill w-full h-2/3"
                        src={SliderMenuPhoto6}
                        alt="image slide 3"
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <img
                        className="object-fill w-full h-2/3"
                        src={SliderMenuPhoto7}
                        alt="image slide 1"
                    />
                </SwiperSlide>
                <SwiperSlide>
                    <img
                        className="object-fill w-full h-2/3"
                        src={SliderMenuPhoto8}
                        alt="image slide 2"
                    />
                </SwiperSlide>
            </Swiper>
        </>
    );
}